module.exports = __webpack_public_path__ + "static/media/beginner.d4a3a84d.png";